import React from 'react';
import styled, { keyframes } from 'styled-components';

/**
 * Seamless infinite marquee. Children are rendered twice in equal groups;
 * the track translates by exactly one group width (-50%) per cycle.
 */
const scroll = keyframes`
  from { transform: translateX(0); }
  to { transform: translateX(-50%); }
`;

const Outer = styled.div`
  overflow: hidden;
  position: relative;
  width: 100%;
  ${(p) =>
    p.$fade &&
    `
    mask-image: linear-gradient(90deg, transparent, black 10%, black 90%, transparent);
    -webkit-mask-image: linear-gradient(90deg, transparent, black 10%, black 90%, transparent);
  `}
`;

const Track = styled.div`
  display: inline-flex;
  width: max-content;
  animation: ${scroll} ${(p) => p.$duration}s linear infinite;
  animation-direction: ${(p) => (p.$reverse ? 'reverse' : 'normal')};
  ${Outer}:hover & {
    animation-play-state: ${(p) => (p.$pauseOnHover ? 'paused' : 'running')};
  }
  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`;

const Group = styled.span`
  display: inline-flex;
  align-items: center;
  gap: ${(p) => p.$gap};
  padding-right: ${(p) => p.$gap};
`;

const Marquee = ({
  children,
  duration = 28,
  reverse = false,
  gap = '2.5rem',
  fade = true,
  pauseOnHover = true,
  className,
}) => (
  <Outer $fade={fade} className={className}>
    <Track $duration={duration} $reverse={reverse} $pauseOnHover={pauseOnHover}>
      <Group $gap={gap}>{children}</Group>
      <Group $gap={gap} aria-hidden="true">{children}</Group>
    </Track>
  </Outer>
);

export default Marquee;
